import { __assign } from "tslib";
import React, { useCallback, useContext, useMemo } from 'react';
import c from 'classnames';
import get from 'lodash/get';
import { BiLoggerContextProvider } from '@wix/da-bi/pkg/BiLogger.context';
import { useTranslation } from 'react-i18next';
import { BiEventType, BiDataHook } from '@wix/da-bi/pkg/constants';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import ArrowDown from '@wix/da-ds/pkg/Icons/ArrowDown';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import { getDeviationResourceType } from '../../../DeviationViews/_helpers';
import { NotificationType } from '../../../Notifications';
import { getDeviationNotificationQueue } from '../../../DeviationPage/redux/helpers';
import FavingIcon from '../../../FaveButton/FavingIcon';
import { useKeyDown } from '../../../utils/hooks/useKeyDown';
import ActionBarItemWrapper from '../../_partials/items/ActionBarItemWrapper';
import ActionBarToggleButton from '../../_partials/items/ActionBarToggleButton';
import { ReactPopperReference } from '../../../Popover/PopperPopover/ReactPopper';
import s from './FavouriteButton.scss';
function getFaveButtonBiData(isFavourite, isCollectionPanelOpen) {
    if (isCollectionPanelOpen) {
        return;
    }
    return {
        evid: isFavourite ? BiEventType.THUMB_CLICK_UNFAVE : BiEventType.THUMB_FAVE,
    };
}
function getDeviationBiData(deviation) {
    return {
        creatorid: get(deviation, 'author.useridUuid'),
        typeid: getDeviationResourceType(deviation),
        itemid: deviation.deviationId,
    };
}
var FavouriteButton = function (_a) {
    var deviation = _a.deviation, actionBarType = _a.actionBarType, isCollectionPanelOpen = _a.isCollectionPanelOpen, onToggleCollectionPanel = _a.onToggleCollectionPanel, onChangeFave = _a.onChangeFave, onArrowClick = _a.onArrowClick;
    var isMobile = useContext(MobileContext);
    var t = useTranslation().t;
    var isAddToFaves2 = useFlag('add_to_faves_2');
    var isNoChangeCollectionMobileFlagEnabled = useFlag('no_change_collection_mobile');
    var keyboardShortcute = useMemo(function () { return ({
        // ctrl-g
        g: function (event) {
            if (actionBarType === 'primary' && event.ctrlKey) {
                onToggleCollectionPanel('primary');
            }
        },
    }); }, [actionBarType, onToggleCollectionPanel]);
    useKeyDown(keyboardShortcute);
    var isFavourited = !!deviation.isFavourited;
    var onClick = function () {
        return onChangeFave(deviation, !isFavourited, getDeviationNotificationQueue(deviation));
    };
    // The favorite button is very concerned with the arrow
    // from the popper notification coming from the icon.
    // We should find a better way to do this if this needs to happen
    // elsewhere.
    var FavingIconWithState = useCallback(function (iconProps) { return (React.createElement(ReactPopperReference, null, function (_a) {
        var ref = _a.ref;
        return (React.createElement(FavingIcon, __assign({}, iconProps, { ref: ref, isFavourited: isFavourited, deviationId: deviation.deviationId })));
    })); }, [isFavourited, deviation.deviationId]);
    return (React.createElement(BiLoggerContextProvider, { value: getDeviationBiData(deviation) },
        React.createElement(ActionBarItemWrapper, { notificationTypes: [
                NotificationType.Collect,
                NotificationType.CollectUndo,
                NotificationType.Fave,
                NotificationType.FaveUndo,
            ], popoverWrapperClassName: c(isAddToFaves2 && s['button-with-dropdown']) },
            React.createElement(ActionBarToggleButton, { onClick: onClick, activated: isCollectionPanelOpen, "data-hook": BiDataHook.DEVIATION_FAVE_BUTTON, label: isMobile
                    ? undefined
                    : t(isFavourited
                        ? 'actionbar.inFavourites'
                        : 'actionbar.addToFavourites'), biData: getFaveButtonBiData(isFavourited, isCollectionPanelOpen), icon: FavingIconWithState }),
            isAddToFaves2 &&
                (!isMobile || !isNoChangeCollectionMobileFlagEnabled) && (React.createElement(PlainButtonOrLink, { className: s['arrow-down-wrapper'], onClick: onArrowClick, biData: {
                    evid: BiEventType.POPUP_CLICK_ADD_TO_COLLECTION,
                    sectionname: 'arrowButton',
                } },
                React.createElement(ArrowDown, { size: IconSize.SMALLER }))))));
};
FavouriteButton.displayName = 'FavouriteButton';
export default FavouriteButton;
//# sourceMappingURL=FavouriteButton.js.map